module.exports = __webpack_public_path__ + "img/ESCONDIDO.0edcdc86.png";